module.exports = __webpack_public_path__ + "static/img/kurs.50c7632.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/leistungen/kurs.png
// module id = Y0xd
// module chunks = 0